import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const PEARLS_BOWLS = 'https://cdn.magicpatterns.com/uploads/taVBn72oMftj2UVQcw4BNH/Gemini_Generated_Image_n74atyn74atyn74a.png';
const NEW_IMG_2 = 'https://cdn.magicpatterns.com/uploads/irDaqRxpjTrHqS1wqQP1wP/Gemini_Generated_Image_ueq30fueq30fueq3.png';
const SODAS = 'https://cdn.magicpatterns.com/uploads/2dfEkEitd5LCgXtq7gpekR/Gemini_Generated_Image_xqua2fxqua2fxqua.png';
const NEW_IMG_3 = 'https://cdn.magicpatterns.com/uploads/dshaJ3W8bhoMNsBkVGynYc/Gemini_Generated_Image_wqeudwqeudwqeudw.png';
const NEW_IMG_5 = 'https://cdn.magicpatterns.com/uploads/p7FmUD4Z3NJKjBZ4KfzR5Q/Gemini_Generated_Image_nsmmsdnsmmsdnsmm.png';
const NEW_IMG_4 = 'https://cdn.magicpatterns.com/uploads/duhpYuPhmdWrESKocEFCL3/Gemini_Generated_Image_4uuo5e4uuo5e4uuo.png';
const galleryItems = [{
  src: PEARLS_BOWLS,
  title: 'PERLAS CLÁSICAS',
  alt: 'Perlas Clásicas de Tapioca'
}, {
  src: NEW_IMG_2,
  title: 'PERLAS DE SABORES',
  alt: 'Perlas de Sabores Coloridas'
}, {
  src: SODAS,
  title: 'SODAS ITALIANAS',
  alt: 'Sodas Italianas con Boba'
}, {
  src: NEW_IMG_3,
  title: 'VARIEDADES DE LECHE',
  alt: 'Variedades de Leche para Bubble Tea'
}, {
  src: NEW_IMG_5,
  title: 'FÓRMULAS LISTAS',
  alt: 'Fórmulas Listas de Bubble Tea'
}];
export function ProductSection() {
  return <section className="bg-white pt-[15px] pb-[15px] space-y-[24px]" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        {/* Gallery Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-extrabold font-sans uppercase mb-4" data-id="element-269">
            <span className="text-[#8B6914] text-[24px] font-[600] font-[Poppins,_sans-serif] pl-[20px] pr-[20px]" data-id="element-270">
              Descubre la{' '}
            </span>
            <span className="text-[#2D5A27] text-[24px] font-[800] font-[Poppins,_sans-serif] pl-[20px] pr-[20px]" data-id="element-271">
              fórmula ganadora
            </span>
            <span className="text-[#8B6914] text-[24px] font-[600] font-[Poppins,_sans-serif]" data-id="element-272">
              {' '}
              de tu próximo negocio
            </span>
          </h2>
          <p className="text-[#8B6914] font-medium tracking-widest uppercase text-sm" data-id="element-273">
            Ingredientes fáciles de conseguir
          </p>
        </motion.div>

        {/* Circular Gallery - Single column, 5 modules centered */}
        <div className="flex flex-col items-center gap-12 md:gap-14 mb-24" data-id="element-274">
          {galleryItems.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex flex-col items-center" data-id="element-275">
              <div className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 rounded-full overflow-hidden mb-5 bg-transparent" data-id="element-276">
                <img src={item.src} alt={item.alt} className="w-full h-full object-cover block transform scale-125" style={{
              padding: 0
            }} data-id="element-277" />
              </div>
              <h3 className="text-base md:text-lg uppercase tracking-wider text-center font-[900] text-[#8A6341] font-['Segoe_UI',_sans-serif]" data-id="element-278">
                {item.title}
              </h3>
            </motion.div>)}
        </div>
      </div>

      {/* Product Presentation - Redesigned */}
      <div className="mt-24" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full py-4 mt-[0px] mb-[0px] bg-[#FF3F3F] pt-[0px] pb-[0px]" data-id="element-280">
          <p className="text-white uppercase sans-serif text-center md:text-2xl tracking-wider m-0 text-[20px] font-[800] bg-[#FF2A004D] pt-[5px] pb-[5px] mt-[0px] mb-[0px]" data-id="element-281">
            INSUMOS FÁCILES DE CONSEGUIR
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-[30px] pb-[30px]" data-id="element-282">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8" data-id="element-283">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold font-sans uppercase leading-tight text-[#2D5A27]" data-id="element-284">
              <span className="block text-[#845834] font-[Cabin,_sans-serif]" data-id="element-285">
                PRESENTAMOS BOBA PROFESSIONAL
              </span>
              <span className="block font-[900] font-[Poppins,_sans-serif]" data-id="element-286">
                EL ARTE DEL BUBBLE TEA🧋
              </span>
            </h2>
          </motion.div>

          {/* Product Spread Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full max-w-3xl mx-auto mb-12" data-id="element-287">
            <img src={NEW_IMG_4} alt="Boba Professional - Pack completo con bebidas y eBook" className="w-full h-auto block" data-id="element-288" />
          </motion.div>

          {/* New Text Blocks */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto pb-12" data-id="element-289">
            <h3 className="text-xl md:text-2xl text-left sans-serif font-[700] pt-[0px] pb-[0px] mt-[50px] mb-[50px] text-[#634D40] font-[Poppins,_sans-serif]" data-id="element-290">
              DEJA DE PERDER DINERO EN PRUEBAS Y ERROR: DOMINA EL NEGOCIO DEL
              BUBBLE TEA CON NUESTRAS ESTRUCTURAS DE COSTOS Y RECETAS PROBADAS.
            </h3>

            <ul className="space-y-6" data-id="element-291">
              <li className="flex items-start" data-id="element-292">
                <div className="flex-shrink-0 w-8 h-8 bg-[#8B6914] rounded-full flex items-center justify-center mr-4 mt-1" data-id="element-293">
                  <ArrowRightIcon className="w-5 h-5 text-white" data-id="element-294" />
                </div>
                <p className="text-gray-700 leading-relaxed sans-serif text-left" data-id="element-295">
                  <strong className="font-bold text-gray-900" data-id="element-296">
                    RENTABILIDAD GARANTIZADA:{' '}
                  </strong>
                  Nuestras fórmulas de costos te permiten saber exactamente cuál
                  es tu margen de ganancia por cada bebida vendida, asegurando
                  que tu negocio sea viable y lucrativo.
                </p>
              </li>
              <li className="flex items-start" data-id="element-297">
                <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1 bg-[#8B6914]" data-id="element-298">
                  <ArrowRightIcon className="w-5 h-5 text-white" data-id="element-299" />
                </div>
                <p className="text-gray-700 leading-relaxed sans-serif text-left" data-id="element-300">
                  <strong className="font-bold text-gray-900" data-id="element-301">
                    RECETAS DE AUTOR LISTAS PARA USAR:{' '}
                  </strong>
                  Accede a más de 70 combinaciones exclusivas de bebidas con
                  perlas popping y té frutal, diseñadas para destacar en el
                  mercado y mantener a tus clientes pidiendo más.
                </p>
              </li>
              <li className="flex items-start" data-id="element-302">
                <div className="flex-shrink-0 w-8 h-8 bg-[#8B6914] rounded-full flex items-center justify-center mr-4 mt-1" data-id="element-303">
                  <ArrowRightIcon className="w-5 h-5 text-white" data-id="element-304" />
                </div>
                <p className="text-gray-700 leading-relaxed sans-serif text-left" data-id="element-305">
                  <strong className="font-bold text-gray-900" data-id="element-306">
                    ESCALA TU NEGOCIO:{' '}
                  </strong>
                  Te revelamos los secretos comerciales del Bubble Tea, desde el
                  cálculo preciso de costos de materia prima hasta estrategias
                  para atraer y fidelizar clientes, permitiéndote pasar de la
                  pasión a la ganancia.
                </p>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}